import React, { useState } from 'react';
import ConfigurationContainer from './containers/ConfigurationContainer';
import { VersionableId } from '../../types/versionableId';
import { FormMode } from '../../types/formMode';
import EsmeFormContainer from './containers/esme/EsmeFormContainer';
import EsmeDeleteDialogContainer from './containers/esme/EsmeDeleteDialogContainer';
import SmscDeleteDialogContainer from './containers/smsc/SmscDeleteDialogContainer';
import SmscFormContainer from './containers/smsc/SmscFormContainer';

type FormOptions = {
  readonly show: boolean;
  readonly mode: FormMode;
  readonly resourceId?: VersionableId;
};

type DialogOptions = {
  readonly show: boolean;
  readonly resourceId?: VersionableId;
}

const INITIAL_FORM_OPTIONS: FormOptions = {
  show: false,
  mode: FormMode.ADD,
};

const INITIAL_DIALOG_OPTIONS: DialogOptions = {
  show: false,
};

const ConfigsView = () => {
  const [esmeFormOptions, setEsmeFormOptions] = useState<FormOptions>(INITIAL_FORM_OPTIONS);
  const [esmeDialogOptions, setEsmeDialogOptions] = useState<DialogOptions>(INITIAL_DIALOG_OPTIONS);

  const handleHideEsmeForm = () => setEsmeFormOptions(INITIAL_FORM_OPTIONS);
  const handleShowEsmeForm = (mode: FormMode, esmeId?: VersionableId) => {
    setEsmeFormOptions({
      mode,
      show: true,
      resourceId: esmeId,
    });
  };

  const handleHideEsmeDeleteDialog = () => setEsmeDialogOptions(INITIAL_DIALOG_OPTIONS);
  const handleShowEsmeDeleteDialog = (esmeId: VersionableId) => {
    setEsmeDialogOptions({
      show: true,
      resourceId: esmeId,
    });
  };

  const [smscFormOptions, setSmscFormOptions] = useState<FormOptions>(INITIAL_FORM_OPTIONS);
  const [smscDialogOptions, setSmscDialogOptions] = useState<DialogOptions>(INITIAL_DIALOG_OPTIONS);

  const handleHideSmscForm = () => setSmscFormOptions(INITIAL_FORM_OPTIONS);
  const handleShowSmscForm = (mode: FormMode, smscId?: VersionableId) => {
    setSmscFormOptions({
      mode,
      show: true,
      resourceId: smscId,
    });
  };

  const handleHideSmscDeleteDialog = () => setSmscDialogOptions(INITIAL_DIALOG_OPTIONS);
  const handleShowSmscDeleteDialog = (smscId: VersionableId) => {
    setSmscDialogOptions({
      show: true,
      resourceId: smscId,
    });
  };

  return (
    <>
      <ConfigurationContainer
        showEsmeForm={handleShowEsmeForm}
        showEsmeDeleteDialog={handleShowEsmeDeleteDialog}
        showSmscForm={handleShowSmscForm}
        showSmscDeleteDialog={handleShowSmscDeleteDialog}
      />

      <EsmeFormContainer
        isOpen={esmeFormOptions.show}
        formMode={esmeFormOptions.mode}
        esmeId={esmeFormOptions.resourceId}
        hideEsmeForm={handleHideEsmeForm}
      />
      <EsmeDeleteDialogContainer
        isOpen={esmeDialogOptions.show}
        esmeId={esmeDialogOptions.resourceId}
        hideEsmeDeleteDialog={handleHideEsmeDeleteDialog}
      />

      <SmscFormContainer
        isOpen={smscFormOptions.show}
        formMode={smscFormOptions.mode}
        smscId={smscFormOptions.resourceId}
        hideSmscForm={handleHideSmscForm}
      />
      <SmscDeleteDialogContainer
        isOpen={smscDialogOptions.show}
        smscId={smscDialogOptions.resourceId}
        hideSmscDeleteDialog={handleHideSmscDeleteDialog}
      />
    </>
  );
}

export default ConfigsView;
